import { DiaryType } from './diary_type';

export class DiaryTypeUtils {
  getIcon(type: DiaryType): string {
    switch (type.name) {
      case 'collation':
        return 'assets/images/diary/types/snack.svg';
      case 'feeling':
        return 'assets/images/diary/types/feeling.svg';
      case 'hydration':
        return 'assets/images/diary/types/hydration.svg';
      case 'meal':
        return 'assets/images/diary/types/meal.svg';
      case 'physical_activity':
        return 'assets/images/diary/types/heart.svg';
      case 'challenge_of_the_day':
        return 'assets/images/diary/types/challenge_of_the_day.svg';
      case 'sleep':
        return 'assets/images/diary/types/sleep.svg';
      case 'excluding_meals':
        return 'assets/images/diary/types/excluding_meals.svg';
      case 'symptoms':
        return 'assets/images/diary/types/symptoms.svg';
      // v1 support
      case 'positive':
        return 'assets/images/diary/types/positive.svg';
      case 'discomfort':
        return 'assets/images/diary/types/discomfort.svg';
      default:
        return 'assets/images/diary/types/meal.svg';
    }
  }

  getLegacyIcon(name: string) {
    switch (name) {
      case 'collation':
        return 'assets/images/diary/types/snack.svg';
      case 'feeling':
        return 'assets/images/diary/types/feeling.svg';
      case 'hydration':
        return 'assets/images/diary/types/hydration.svg';
      case 'meal':
        return 'assets/images/diary/types/meal.svg';
      case 'physical_activity':
        return 'assets/images/diary/types/heart.svg';
      case 'challenge_of_the_day':
        return 'assets/images/diary/types/challenge_of_the_day.svg';
      case 'sleep':
        return 'assets/images/diary/types/sleep.svg';
      case 'excluding_meals':
        return 'assets/images/diary/types/excluding_meals.svg';
      case 'symptoms':
        return 'assets/images/diary/types/symptoms.svg';
      // v1 support
      case 'positive':
        return 'assets/images/diary/types/positive.svg';
      case 'discomfort':
        return 'assets/images/diary/types/discomfort.svg';
      default:
        return 'assets/images/diary/types/meal.svg';
    }
  }

  getLegacyLabel(name: string) {
    switch (name) {
      case 'collation':
        return 'Collation';
      case 'feeling':
        return 'Ressentis';
      case 'hydration':
        return 'Hydratation';
      case 'meal':
        return 'Repas';
      case 'physical_activity':
        return 'Activité physique';
      case 'challenge_of_the_day':
        return 'Défi du jour';
      case 'sleep':
        return 'Sommeil';
      case 'excluding_meals':
        return 'Hors repas';
      case 'symptoms':
        return 'Symptômes';
      // v1 support
      case 'positive':
        return 'Positif';
      case 'discomfort':
        return 'Inconfort';
      default:
        return 'Repas';
    }
  }
}
